<template>
  <v-container fluid style="margin:0; padding:0">
    <div @drop="handleFileDrop" v-show="!readOnly">
      <br />
      <div ref="dragbox" :class="['file-wrapper', isOver ? 'isOver' : '']">
        <input
          type="file"
          name="file-input"
          :multiple="imageMode ? 'False' : 'True'"
          @change="handleFileInput"
        />
        <div v-if="imageMode">
          <v-img :src="currentImage" class="image" />Bild ändern
        </div>
        <div v-else>Hier Dokumente ablegen oder zum Auswählen klicken.</div>
      </div>
      <ul v-if="!imageMode">
        <li v-for="file in tempFiles" :key="file.name">
          {{ file.name }} ({{ file.resource.size / 1000 }} KB)
          <v-btn @click="removeFile(file.name)" title="Remove">X</v-btn>
        </li>
      </ul>
      <v-snackbar :timeout="4000" v-model="showImageTypeNotice"
        >Für das Hochladen von Bilddateien sind nur die Typen ".gif", ".jpg",
        ".jpeg" und ".png" erlaubt.</v-snackbar
      >
    </div>
    <div v-if="imageMode && readOnly" class="file-wrapper">
      <v-img :src="currentImage" class="image" />
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import dataMixin from '../../../mixins/data-mixin';

export default {
  name: 'BUploadZone',
  inject: {
    _formIdentifier: {
      default() {
        return undefined;
      }
    }
  },
  props: {
    readOnly: { type: Boolean, default: false },
    imageMode: { type: Boolean, default: false },
    filePath: { type: String, default: 'persistentData.data.files.data' }
  },
  mixins: [
    dataMixin('files', self => `${self.filePath}`),
    dataMixin('tempFiles', 'transientData.tempFiles', [])
  ],
  data() {
    return {
      isOver: false,
      allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif'],
      showImageTypeNotice: false
      //loadedImage: require('../../../assets/upload/default_profil_image.jpg')
    };
  },
  computed: {
    currentImage() {
      return this.loadedImage;
    }
  },
  methods: {
    handleFileDrop(e) {
      let files = e.dataTransfer.files;
      this.storeFiles(files);
    },
    handleFileInput(e) {
      let files = e.target.files;
      this.storeFiles(files);
    },

    storeFiles(files) {
      if (!files) return;
      [...files].forEach(f => {
        if (!this.tempFiles.find(x => x.name == f.name)) {
          if (!this.imageMode || this.allowedImageTypes.includes(f.type)) {
            this.submitFile(f);
            this.emitInput(f);
          } else {
            this.showImageTypeNotice = true;
          }
        }
      });
      this.isOver = false;
    },

    removeFile(name) {
      var removableIndex = this.tempFiles.findIndex(tf => tf.name == name);
      if (removableIndex >= 0) {
        var tempFilesCopy = _.cloneDeep(this.tempFiles);
        tempFilesCopy.splice(removableIndex, 1);
        this.tempFiles = tempFilesCopy;
      }

      removableIndex = this.files.findIndex(
        f => f.data.name == name || f.data == name
      );
      if (removableIndex >= 0) {
        var filesCopy = _.cloneDeep(this.files);
        filesCopy.splice(removableIndex, 1);
        this.files = filesCopy;
      }

      this.emitInput();
    },

    emitInput(value) {
      return this.$emit('input', value);
    },

    submitFile(file) {
      let formData = new FormData();
      formData.append('file', file);

      axios
        .post('/rest/v1/dateien', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          window.console.log(JSON.stringify(response));
          if (this.imageMode) {
            this.files = { data: { name: response.data.data } };
            this.tempFiles = [
              { resource: file, id: undefined, name: response.data.data }
            ];
            this.loadImagePreview();
          } else {
            this.files = [
              ...this.files,
              { data: { name: response.data.data } }
            ];
            this.tempFiles = [
              ...this.tempFiles,
              { resource: file, id: undefined, name: response.data.data }
            ];
          }
          this.emitInput();
        })
        .catch(error => {
          window.console.log(JSON.stringify(error));
        });
    },

    loadImagePreview() {
      var reader = new FileReader();
      reader.onload = e => {
        this.loadedImage = e.target.result;
      };
      reader.readAsDataURL(this.tempFiles[0].resource);
    },

    initializeTempDataItem(file) {
      axios
        .get('/rest/v1/dateien/' + file.uuid, {
          responseType: 'arraybuffer'
        })
        .then(response => {
          var loadedFile = {
            resource: new File([response.data], file.data.name, {
              type: file.data.mimeType
            }),
            uuid: file.uuid,
            name: file.data.name
          };

          if (this.imageMode) {
            this.tempFiles = [loadedFile];
            this.loadImagePreview();
          } else {
            this.tempFiles = [...this.tempFiles, loadedFile];
          }
        })
        .catch(error => {
          window.console.log(JSON.stringify(error));
        });
    },

    initializeTempData() {
      // If we are not in image mode, handle files as array
      if (!this.imageMode) {
        if (this.files == undefined) this.files = [];
        else {
          this.files.forEach(f => {
            if (
              f.uuid == undefined ||
              this.tempFiles.findIndex(tf => tf.uuid === f.uuid) >= 0
            ) {
              return;
            }

            this.initializeTempDataItem(f);
          });
        }
      } else {
        if (this.files != undefined) {
          this.initializeTempDataItem(this.files);
        }
      }
    }
  },

  mounted() {
    if (this.tempFiles == undefined) this.tempFiles = [];
    else if (this.tempFiles.lenght > 0) {
      this.loadImagePreview();
    }

    this.initializeTempData();

    this.$refs.dragbox.addEventListener('dragover', () => {
      this.isOver = true;
    });
    this.$refs.dragbox.addEventListener('dragleave', () => {
      this.isOver = false;
    });
  },

  watch: {
    files() {
      if (this.tempFiles == undefined || this.tempFiles.length < 1) {
        this.initializeTempData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-wrapper {
  text-align: center;
  //height: 6em;
  border-radius: 5px;
  vertical-align: middle;
  // display: table-cell;
  position: relative;
  // width: 800px;
  overflow: hidden;
  background: lightgrey;
  margin: 0;
  padding: 0;
}
.file-wrapper.isOver {
  background: gray;
}
.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 300px;
  // height: 6em;
}
</style>